
import '../../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';
import { RequestAssignedMaterialToPackage } from '../../../models/requestAssignedMaterialToPackage';

export default class AssignMaterialsToPackagesDialog {

    static $inject = ['$mdDialog', '$q'];
    
    requestDetailEdit: RequestDetailEdit;
    editRequestAssignToMaterial : RequestAssignedMaterialToPackage;
    editIndex: number;
    isLoading: boolean;
    
    constructor(private _$mdDialog: ng.material.IDialogService,
        private $q: ng.IQService
    ) {
    }

    $onInit(): void {
        this.editRequestAssignToMaterial = angular.copy(this.requestDetailEdit.requestMaterial
            .requestAssignedMaterialToPackage[this.editIndex]);
    }

    dimension(len: string, width: string, height: string, uom: string): string {
        return len + 'L x' + width + 'W x' + height + 'H ' + uom;
    }

    isPackageTypeEnvelope(packageTypeId: string): boolean {
        if (packageTypeId !== undefined && packageTypeId !== null && packageTypeId.toLocaleLowerCase() === "envelope")
            return true;
        return false;
    }

    getTotalAssignedPc(rqAssignToMaterial: RequestAssignedMaterialToPackage) : number {
        var total = 0;
        if (rqAssignToMaterial !== undefined && rqAssignToMaterial !== null && rqAssignToMaterial.requestPackages !== undefined &&
            rqAssignToMaterial.requestPackages !== null) {
            for (let pkgs of rqAssignToMaterial.requestPackages) {
                if (!pkgs.isDeleted) {
                    total = total + (pkgs.quantity !== undefined ? pkgs.quantity : 0);
                }
            }   
        }
        
        return total;
    }

    cancel(): void {
        this._$mdDialog.cancel();
    }

    saveAssignMaterials(): void {
        this._$mdDialog.hide();

        this.editRequestAssignToMaterial.assignedPc = this.getTotalAssignedPc(this.editRequestAssignToMaterial);
        
        this.requestDetailEdit.requestMaterial
            .requestAssignedMaterialToPackage[this.editIndex] = this.editRequestAssignToMaterial;
        
    }

    
    shouldDisableSave(): boolean {
        var totalAssigned = this.getTotalAssignedPc(this.editRequestAssignToMaterial);
        if (totalAssigned === this.editRequestAssignToMaterial.requestMaterials.quantity) {
            return false;
        }
        return true;
    }


}

angular
    .module('deliveryCreate.app')
    .component('assignMaterialsToPackagesDialog',
    {
        template: require('../templates/assignMaterialsToPackagesDialog.html'),
        controller: AssignMaterialsToPackagesDialog,
        controllerAs: 'vm',
        bindings: {
            requestDetailEdit: '=',
            editIndex: '=',
            isLoading: '='
       }
    });


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/assignMaterialsToPackagesDialog/controllers/assignMaterialsToPackagesDialogController.ts
 **/